import { GetFunc } from "../../types";

export const getOptions = (getWidth: GetFunc, getHeight: GetFunc) => ({
  map: {
    top: getHeight(-10),
    left: getWidth(-320)
  },
  icon: {
    top: getHeight(200),
    left: getWidth(97)
  }
});